/*
 * File: UIDialogToolbar.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Wrapper for Material UI Appbar and Toolbar for a UIDialog component
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import PropTypes from "prop-types";

// ------------------------------------------------

const styles = theme => ({
  appBar: {
    position: "relative",
    boxShadow: "none",
    flex: "0 0 auto"
  },
  flex: {
    flex: 1,
    textAlign: "center",
    color: theme.palette.common.white,
    margin: "0 auto",
    fontWeight: 300,
    fontSize: "1.5em",
    letterSpacing: ".1rem"
  },
  rightNav: {
    position: "absolute",
    right: 20,
    color: theme.palette.common.white
  },
  noAppBarNav: {
    padding: 10,
    height: 26,
    borderBottom: "1px solid #ddd",
    marginBottom: 20
  }
});

/**
 * @param classes object CSS Style properties
 * @param title string Title for toolbar
 * @param function Component for toolbar right navigation
 */

const UIDialogToolbar = ({ classes, title, rightNav }) => {
  let getRightNav = () => {
    let nav = rightNav ? rightNav() : null;
    return <div className={classes.rightNav}>{nav}</div>;
  };

  return (
    <div>
      {title && (
        <AppBar className={classes.appBar}>
          <Toolbar>
            <Typography variant="h6" color="inherit" className={classes.flex}>
              {title}
            </Typography>
            {getRightNav()}
          </Toolbar>
        </AppBar>
      )}
      {!title && <div className={classes.noAppBarNav}>{getRightNav()}</div>}
    </div>
  );
};

UIDialogToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  rightNav: PropTypes.func
};

export default withStyles(styles)(UIDialogToolbar);
